import React, { createContext, useEffect, useState, useContext } from "react";
import { ApiService, ApiLoginService } from "../services";
import useLocalStorage from "./useLocalStorage";

const SettingsContext = createContext(null);

const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({}); //useLocalStorage('settings');

  useEffect(() => {
    if (Object.keys(settings).length > 0) {
      return;
    }
    refreshSettings();
  }, []);

  const refreshSettings = () => {
    var token = localStorage.getItem("uwAccessToken");
    var rtoken = localStorage.getItem("uwRefreshToken");
    var expires = localStorage.getItem("uwExpiresIn");
    if (token && rtoken && expires && expires > 0) {
      ApiService({ method: "GET", route: "c/me" }).then((response) => {
        console.log(response);
        if (response.data) {
          setSettings(response.data.data);
        }
      });
    } else {
      ApiLoginService("GET", "c/settings").then((response) => {
        setSettings(response.data || {});
        return response;
      });
    }
  };

  useEffect(() => {
    localStorage.setItem("settings", JSON.stringify(settings));
  }, [settings]);

  return (
    <SettingsContext.Provider
      value={{ settings, setSettings, refreshSettings }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export { SettingsProvider, SettingsContext };

export default () => useContext(SettingsContext);
